import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'nk-card-header',
  imports: [CommonModule],
  templateUrl: './card-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardHeaderComponent implements OnInit {
  @Input() public title: string | undefined;
  @Input() public favicon: string | undefined;
  @Input() public brandCard: boolean | undefined;
  @Input() public brandColor: string | undefined;
  @Input() public colorize: string | undefined;
  @Input() public andClass = '';
  @Input() public transparent = true;
  @Input() public cardList = false;

  // Blue, red, yellow etc

  public ngOnInit(): void {
    if (!this.brandColor) {
      this.brandColor = '';
    }
    if (!this.colorize) {
      this.colorize = '';
    }
  }
}
